<template>
  <div>
    <NavHeaderBar title="关于学分" :onClickRight="onClickRight" rightArrow />
    <div v-if="imgUrl" style="margin-top: 40px;padding:10px;">
      <img width="100%" :src="imgUrl" />
    </div>
  </div>
</template>
<script>
import { queryGetCreditDetail } from "@/config/user";
import { getEnv } from "@/config/utils";
import share from "@/mixins/share";
import { Toast } from "vant";
export default {
  name: "Credit",
  mixins: [share],
  data: function() {
    return {
      imgUrl: ""
    };
  },
  mounted: function() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      queryGetCreditDetail(this.$route.query.project).then(result => {
        if (result.success == "ok") {
          this.imgUrl = result.data.aboutCreditPicUrl;
          document.title = result.data.title;
          if (getEnv() !== "h5" && result.success == "ok") {
            const { shareimg, sharedesc, share } = result.data;
            this.onShare({
              link:
                window.location.href.split("?")[0] +
                "?project=" +
                this.$route.query.project,
              title: share,
              imgUrl: shareimg,
              desc: sharedesc
            });
          }
        } else {
          Toast.fail(result?.msg);
        }
      });
    },
    onClickRight() {
      this.$router.replace({
        path: "/livehome",
        query: { project: this.$route.query.project }
      });
    }
  }
};
</script>

<style></style>
